import { mutators, queries, schema } from "@oblique/shared/zero"
import { ZeroProvider } from "@rocicorp/zero/react"
import type { ReactNode } from "react"
import { usePlatform } from "../platform/context"
import { useAuth } from "../providers/auth"

export const ZeroInit = ({ children }: { children: ReactNode }) => {
	const { authToken, user } = useAuth()
	const platform = usePlatform()
	const userID = user?.id ?? "anonymous"

	return (
		<ZeroProvider
			{...{
				schema,
				server: platform.zeroOrigin,
				userID,
				mutators,
				auth: authToken,
				context: { userId: userID },
				queries: queries,
				// uncomment this to see zero debug logs
				// logLevel: "debug" as const,
			}}
		>
			{children}
		</ZeroProvider>
	)
}
